import { Box, LinearProgress } from "@mui/material";
import { Suspense, lazy } from "react";
import { mapService } from "../../../services/map/mapService";
import MapSkeleton from "../maps/MapSkeleton";

const NeshanMapView = lazy(() => import("../maps/NeshanMapView"));

/**
 * @typedef {import("../maps/NeshanMapView").MapMarkerData} MapMarkerData
 * @typedef {import("../maps/NeshanMapView").MapPolygonData} MapPolygonData
 */

// mapServiceKind = Custom | Default | Neshan
const CustomMap = ({
  loading = false,
  center = mapService.getDefaultCenter(),
  zoom = mapService.getDefaultZoom(),
  mapServiceKind = "Default",
  customMapUrl = "",
  height = 500,
  readOnly = true,
  markerPosition = null,
  draggableMarker = false,
  markers = [],
  polygons = [],
  onMapClick,
  onMarkerDragEnd,
  onMarkerSelect,
}) => {
  const resolvedCustomMapUrl =
    mapServiceKind === "Custom" && customMapUrl ? customMapUrl : undefined;

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      {loading && (
        <Box
          sx={{
            position: "absolute",
            top: 8,
            left: 16,
            right: 16,
            zIndex: 1000,
          }}
        >
          <LinearProgress />
        </Box>
      )}

      <Suspense fallback={<MapSkeleton height={height} />}>
        <NeshanMapView
          center={center}
          zoom={zoom}
          height={height}
          customMapUrl={resolvedCustomMapUrl}
          loading={loading}
          readOnly={readOnly}
          markerPosition={markerPosition}
          draggableMarker={draggableMarker}
          markers={markers}
          polygons={polygons}
          onMapClick={onMapClick}
          onMarkerDragEnd={onMarkerDragEnd}
          onMarkerSelect={onMarkerSelect}
        />
      </Suspense>
    </Box>
  );
};

export default CustomMap;
